<template>
	<div class="manage">
		<div class="top" style="margin: 0px;">
			<!-- 售后订单列表 -->
			<el-row>
				<el-col :span="24" class="table" style="margin: 0px;">
					<div ref="height_top" class="order-card-container"
						:style="{ height: tableHeight - 20 + 'px', overflowY: 'auto' }">
						<div v-loading="loading" class="order-card-list">
							<div v-for="order in tableData" :key="order.key" class="order-card"
								@dblclick="viewAfterSales(order)">
								<div class="card-header">
									<el-row>
										<el-col :span="6">
											<div class="header-item">
												<span class="item-label">订单日期</span>
												<span class="item-value">{{ order.create_time }}</span>
											</div>
										</el-col>
										<el-col :span="6">
												<div class="header-item">
													<span class="item-label">订单号</span>
													<span class="item-value order-no">{{ order.pay_no }}</span>
												</div>
											</el-col>
                                            <el-col :span="6">
											<div class="header-item">
												<span class="item-label">申请时间</span>
												<span class="item-value">{{ order.create_time }}</span>
											</div>
										</el-col>
                                        <el-col :span="6">
											<div class="header-item">
												<span class="item-label">售后数量</span>
												<span class="item-value">{{ order.asnum || 0 }}
                                                    件</span>
											</div>
										</el-col>
										</el-row>
                                        
								</div>
								<div class="card-body">
									<div class="body-left">
										<div class="info-row">
											<el-row>
												<el-col :span="6">
													<el-row>
														<el-col :span="12">
															<div class="info-item">
																<span class="info-label">商品数量</span>
																<span class="info-value">{{ order.total_num || 0 }}
																	件</span>
															</div>
														</el-col>
														<el-col :span="12">
															<div class="info-item">
																<span class="info-label">商品金额</span>
																<span class="info-value price">¥{{
																	order.total_goods_money
																}}</span>
															</div>
														</el-col>
													</el-row>
												</el-col>
												<el-col :span="6">
													<el-row>
														<el-col :span="12" v-if="Number(order.goods_discount) > 0">
															<div class="info-item"
																v-if="Number(order.goods_discount) > 0">
																<span class="info-label">优惠金额</span>
																<span class="info-value discount">
																	<el-tag type="danger" size="small"
																		effect="dark">省</el-tag>
																	¥{{ order.goods_discount || '0.00' }}
																</span>
															</div>
														</el-col>
														<el-col :span="12">
															<div class="info-item">
																<span class="info-label">运费</span>
																<span class="info-value price">¥{{ order.freight_fee ||
																	'0.00'
																}}</span>
															</div>
														</el-col>
													</el-row>
												</el-col>
                                                <el-col :span="6">
													<div class="info-item">
														<span class="info-label">订单金额</span>
														<span class="info-value price">¥{{ order.total_order_money ||
															'0.00' }}</span>
													</div>
												</el-col>
                                                <el-col :span="2">
										<el-row>
											<el-col :span="24">
												<div class="info-item">
													<span class="info-label">处理结果</span>
													<el-tooltip v-if="order.state === 2" :content="order.reject_reason || '暂无拒绝原因'" placement="top">
														<el-tag type="danger" style="width: min-content;" size="small" effect="dark">已拒绝</el-tag>
													</el-tooltip>
													<el-tag v-else-if="order.state === 1" style="width: min-content;" type="success" size="small" effect="dark">已处理</el-tag>
													<el-tag v-else style="width: min-content;" type="warning" size="small" effect="dark">处理中</el-tag>
												</div>
											</el-col>
											
										</el-row>
									</el-col>
												<el-col :span="4">
																<div class="body-right"
																	style="display: flex; justify-content: flex-end; align-items: center; height: 100%; width: 100%;">
																	<div class="button-group">
																		<!-- 查看售后详情按钮 -->
																		<el-button
																			type="primary" size="small" text
																			@click="viewAfterSales(order)">查看售后详情</el-button>
																	</div>
																</div>
															</el-col>
											</el-row>
										</div>
									</div>
								</div>
							</div>
							<div v-if="tableData.length === 0" :style="{ height: tableHeight - 20 + 'px' }">
								<el-empty description="暂无数据" :image-size="120">
									<template #description>
										<div class="empty-title">暂无数据</div>
										<div class="empty-subtitle"></div>
									</template>
								</el-empty>
							</div>
						</div>
					</div>
				</el-col>
				<el-col :span="24" class="page" style="display: flex; justify-content: flex-end;">
					<el-pagination :pager-count="5" size="small" class="pagination" :current-page="page" background
						:page-size="parseInt(page_size)" layout="prev, pager, next"
						@current-change="handleCurrentChange" :total="total">
					</el-pagination>
				</el-col>
			</el-row>
		</div>
	</div>

	<!-- 查看售后详情弹窗 -->
	<afterSales v-model:visible="afterSalesVisible" :order="currentOrder" :showApplyButton="false" :aftersale_id="currentAftersaleId"></afterSales>
</template>
<script>
import { ElMessage, ElMessageBox } from 'element-plus'
import { Clock } from '@element-plus/icons-vue';
import '../../assets/user/index.css'
import afterSales from '../public/afterSales';
export default {
	components: {
		Clock,
		afterSales
	},
	data() {
		return {
			tableData: [],
			loading: false,
			total: 0,
			page: 1,
			tableHeight: 400,
			page_size: 120,
			currentOrder: {},
			currentAftersaleId: null,
			afterSalesVisible: false
		}
	},
	mounted() {
		this.search();
		this.tableHeight_fun();
		window.addEventListener('resize', this.tableHeight_fun);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.tableHeight_fun);
	},
	methods: {
		getStatusType(order) {
			const state = order.state;
			if (state === 0 && order.card_state === 1) {
				return 'warning';
			}
			const typeMap = {
				0: 'danger',
				1: 'warning',
				2: 'info',
				4: 'success',
				'-1': 'info',
			};
			return typeMap[state] || 'info';
		},
		getStatusText(order) {
			const state = order.state;
			if (state === 0 && order.card_state === 1) {
				return '待支付-等待审核';
			}
			const textMap = {
				0: '待支付',
				3: '等待商家确认',
				1: '待发货',
				2: '待收货',
				4: '已完成',
				'-1': '已取消',
			};
			return textMap[state] || state;
		},
		viewAfterSales(order) {
			this.currentOrder = order;
			this.currentAftersaleId = order.aftersale_id || order.id;
			this.afterSalesVisible = true;
		},
		grabble() {
			this.page = 1;
			this.search();
		},
		handleCurrentChange(val) {
			this.page = val;
			this.search();
		},
		tableHeight_fun() {
			this.$nextTick(() => {
				if (this.$refs.height_top) {
					this.tableHeight = window.innerHeight - this.$refs.height_top.getBoundingClientRect().top - 100;
				}
			})
		},
		async search() {
			this.loading = true;
			try {
				const res = await this.$axios.post('/api/yunsys.Order/getaftersale', {
					page: this.page,
					ps: this.page_size
				});
				const data = res.data;
				this.loading = false;
				if (data.code !== 0) {
					return ElMessage({
						message: data.msg,
						type: 'error',
						grouping: true
					});
				}
				var obj = this;
				this.total = data.data.total || data.data.length || 0;
				var key = 0;
				const orderList = data.data.data || data.data || [];
				orderList.forEach(item => {
					key = key + 1;
					item.key = (obj.page - 1) * obj.page_size + key;
				});
				this.tableData = orderList;
			} catch (err) {
				this.loading = false;
				console.error('获取订单列表失败:', err);
				return ElMessage({
					message: '系统错误',
					type: 'error',
					grouping: true
				});
			}
		}
	}
}
</script>
<style lang="less" scoped>
/* 订单卡片列表样式 */
.order-card-container {
	background: #f5f7fa;
	padding: 6px 6px 5px 6px;
}

.order-card-list {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.order-card {
	background: #fff;
	border-radius: 8px;
	padding: 8px 12px;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
	transition: all 0.3s ease;
}

.order-card:hover {
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
	transform: translateY(-2px);
}

.card-header {
	padding-bottom: 6px;
	border-bottom: 1px solid #f0f0f0;
	margin-bottom: 8px;
	align-items: center;
}

.confirm-tip {
	display: flex;
	align-items: center;
	gap: 4px;
	margin-left: auto;
	flex-shrink: 0;
	font-size: 12px;
	color: #ff8a5c;
	background: #fff5f0;
	padding: 4px 10px;
	border-radius: 4px;
}

.header-item {
	display: flex;
	flex-direction: column;
	gap: 1px;
	line-height: 1.5;
}

.item-label {
	font-size: 11px;
	color: #999;
}

.item-value {
	font-size: 13px;
	color: #333;
}

.order-no {
	font-family: 'Courier New', monospace;
	font-weight: 600;
}

.card-body {
}

.body-left {
}

.info-row {
}

.info-item {
	display: flex;
	flex-direction: column;
	gap: 1px;
}

.info-label {
	font-size: 11px;
	color: #999;
}

.info-value {
	font-size: 13px;
	color: #333;
}

.price {
	color: #ff8a5c;
	font-weight: 700;
}

.discount {
	color: #ff4d4f;
	font-weight: 700;
	font-size: 16px;
	display: flex;
	align-items: center;
	gap: 4px;
}

.discount .el-tag {
	font-size: 11px;
	padding: 0 6px;
	height: 20px;
	line-height: 20px;
	border-radius: 3px;
}

.body-right {
	display: flex;
	gap: 16px;
	align-items: center;
	justify-content: flex-end;
}

.button-group {
	display: flex;
	gap: 6px;
	justify-content: flex-end;
	align-items: center;
}

.status-tag {
	width: max-content;
	margin-left: auto;
	font-size: 13px;
	padding: 13px 10px;
}

:deep(.el-pagination.is-background .el-pager li.is-active) {
	background-color: #ff8a5c;
}

</style>